<template>
  <v-container fluid>
    <v-row justify="start">
      <v-col
        class="text-h3 gray--text"
        cols="auto"
      > Fundoscopia</v-col>

      <v-col cols="auto">
        <v-btn
          color="light-blue"
          @click="handleNormal()"
          :dark="!attendanceEsigned"
          :disabled="attendanceEsigned"
        >
          Normal
        </v-btn>
      </v-col>
      <!---->
      <!-- <v-col cols="5"> -->
      <!--   <v-btn -->
      <!--     color="light-blue" -->
      <!--     @click="handleNormal(true)" -->
      <!--     :dark="!attendanceEsigned" -->
      <!--     :disabled="attendanceEsigned" -->
      <!--   > -->
      <!--     Normal Lio -->
      <!--   </v-btn> -->
      <!---->
      <!-- </v-col> -->
      <!-- <v-col -->
      <!--   class="text-h3 gray--text" -->
      <!--   cols="auto" -->
      <!-- > Tonometria </v-col> -->
    </v-row>

    <v-row>
      <v-col cols="3">
        <v-row dense>
          <v-col>
            <v-combobox
              ref="site"
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Local"
              :items="facilitatorSite"
              @change="handleFacilitatorChange(facilitator, '\n', ' >', true); focusNextField('site')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              ref="visibility"
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Visibilidade"
              :items="facilitatorVisibility"
              @change="handleFacilitatorChange(facilitator, '', ',', false, 'VISIBILIDADE:'); focusNextField('visibility')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              ref="vitreo"
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Vitreo"
              :items="facilitatorVitreo"
              @change="handleFacilitatorChange(facilitator, '', ',', false, 'VITREO:'); focusNextField('vitreo')"
              background-color="white"
              :disabled="attendanceEsigned"

            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              ref="papila"
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Papila"
              :items="facilitatorPappila"
              @change="handleFacilitatorChange(facilitator, '', ',', false, 'PAPILA:' ); focusNextField('papila')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              ref="vaso"
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Vaso"
              :items="facilitatorVaso"
              @change="handleFacilitatorChange(facilitator, '', ',', false, 'VASO:'); focusNextField('vaso')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              ref="retina"
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Retina"
              :items="facilitatorRetina"
              @change="handleFacilitatorChange(facilitator, '', ',', false, 'RETINA:'); focusNextField('retina')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              ref="macula"
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Macula"
              :items="facilitatorMacula"
              @change="handleFacilitatorChange(facilitator, '', ',' , false, 'MACULA:'); focusNextField('macula')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-combobox
              ref="intensity"
              v-model="facilitator"
              outlined
              dense
              hide-details
              label="Intensidade/Localização"
              :items="facilitatorIntensity"
              @change="handleFacilitatorChange(facilitator, '', ',', true); focusNextField('macula')"
              background-color="white"
              :disabled="attendanceEsigned"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="9">
        <v-row dense>
          <v-col>
            <v-textarea
              v-model="fundoscopy.description"
              v-uppercase
              solo
              dense
              :hide-details="!hasErrors"
              :error-messages="errors.description"
              rows="13"
              placeholder="Digite os dados da fundoscopia..."
              background-color="white"
              auto-grow
              :disabled="attendanceEsigned"
              @input="handleDescriptionChange"
            />
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col cols="auto">
            <SaveStatus
              :saving="saveManager.isSaving"
              :pending="saveManager.pendingSave"
              :saved-at="fundoscopy.updatedAt"
              :loading="fundoscopyLoading"
              :error="hasErrors || saveManager.isError"
              not-saved-message="A Fundoscopia ainda não foi salva."
            />
          </v-col>
          <v-col cols="auto">
            <v-btn
              color="light-blue"
              dark
              @click="saveManager.triggerManualSave()"
              :loading="isLoading || saveManager.isSaving"
              :disabled="attendanceEsigned"
            >
              Salvar Fundoscopia
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row dense>
              <v-col class="text-h5 gray--text">
                Olho direito
              </v-col>
              <v-col class="text-h5 gray--text">
                Olho esquerdo
              </v-col>
            </v-row>

            <v-row dense>
              <v-col v-if="fundoscopy.internalRight">
                <FileUpload
                  ownerType="Fundoscopy::InternalRight"
                  :ownerId="fundoscopy.internalRight.id"
                  :disabled="attendanceEsigned"
                />
              </v-col>

              <v-col v-if="fundoscopy.internalLeft">
                <FileUpload
                  ownerType="Fundoscopy::InternalLeft"
                  :ownerId="fundoscopy.internalLeft.id"
                  :disabled="attendanceEsigned"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col class="text-h5 gray--text">
            Imagens Adicionais 
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-row dense>
              <v-col class="text-h5 gray--text">
                Olho direito
              </v-col>
            </v-row>

            <v-row dense>
              <v-col v-if="fundoscopy.externalRight">
                <FileUpload
                  ownerType="Fundoscopy::ExternalRight"
                  :ownerId="fundoscopy.externalRight.id"
                  :disabled="attendanceEsigned"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col>
            <v-row dense>
              <v-col class="text-h5 gray--text">
                Olho esquerdo
              </v-col>
            </v-row>

            <v-row dense>
              <v-col v-if="fundoscopy.externalLeft">
                <FileUpload
                  ownerType="Fundoscopy::ExternalLeft"
                  :ownerId="this.fundoscopy.externalLeft.id"
                  :disabled="attendanceEsigned"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FUNDOSCOPY_FACILITATORS from "@/graphql/fundoscopy/fundoscopy_facilitators.gql";
import GET_FUNDOSCOPY from "@/graphql/fundoscopy/fundoscopy.gql";
import SAVE_FUNDOSCOPY from "@/graphql/fundoscopy/save_fundoscopy.gql";

import SaveStatus from "@/components/ui/form/save_status/index.vue";

import { AutoSaveManager } from "@/services/AutoSaveManager/index.js";

export default {
  name: "Fundoscopy",
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
  },
  components: {
    SaveStatus,
  },
  data() {
    return {
      fundoscopyFacilitators: [],
      fundoscopy: {},
      facilitator: [],
      saveManager: null,
      errors: {},
    };
  },

  apollo: {
    fundoscopyFacilitators: {
      query: FUNDOSCOPY_FACILITATORS,
    },

    fundoscopy: {
      query: GET_FUNDOSCOPY,
      fetchPolicy: "no-cache",
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
      watchLoading(isLoading) {
        if (isLoading) {
          this.$store.dispatch("updateLoading", true);
        } else {
          setTimeout(() => {
            this.$store.dispatch("updateLoading", false);
          }, 1000);
        }
      },
    },
  },

  created() {
    this.saveManager = new AutoSaveManager({
      formName: "Fundoscopia",
      beforeSave: () => this.beforeSave(),
      onSave: () => this.onSave(),
      autoSaveTimeout: 900000, // 15 minutes
    });
  },
  watch: {
    $route() {
      this.triggerManualSave();
    },
  },
  computed: {
    isLoading() {
      return (
        this.fundoscopyLoading || this.$apollo.queries.fundoscopyFacilitators.loading
      );
    },
    fundoscopyLoading() {
      return !this.fundoscopy.id;
    },
    facilitatorSite() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "site",
      });
    },
    facilitatorVisibility() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "visibility",
      });
    },
    facilitatorVitreo() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "vitreo",
      });
    },
    facilitatorPappila() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "pappila",
      });
    },
    facilitatorVaso() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "vaso",
      });
    },
    facilitatorRetina() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "retina",
      });
    },
    facilitatorintensity() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "intensity",
      });
    },
    facilitatorMacula() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "macula",
      });
    },
    facilitatorIntensity() {
      return this.lodash.filter(this.orderedfacilitators, {
        facilitatorType: "intensity",
      });
    },
    orderedfacilitators() {
      return this.lodash.orderBy(
        this.fundoscopyFacilitators,
        [
          (e) =>
            e.text
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, ""),
        ],
        ["asc"]
      );
    },
    hasErrors() {
      return Object.keys(this.errors).length > 0;
    },
  },
  methods: {
    focusNextField(currentRef) {
      const fieldsOrder = ["site", "visibility", "vitreo", "papila", "vaso", "retina", "macula", "intensity"];
      const currentIndex = fieldsOrder.indexOf(currentRef);

      if (currentIndex !== -1 && currentIndex < fieldsOrder.length - 1) {
        const nextRef = fieldsOrder[currentIndex + 1];
        const nextField = this.$refs[nextRef];

        if (nextField && nextField.focus) {
          nextField.focus();
        }
      }
    },

    handleFacilitatorChange(e, textBefore = "", textAfter = "", removeLastChar = false, title = false) {
      if (title)  {
      const fundoscopyDescription = this.fundoscopy.description.split(/\r\n|\r|\n/)
      const lastPartOfDescription = fundoscopyDescription[fundoscopyDescription.length - 1]

      let regex = new RegExp(title, "g");
      let count = (lastPartOfDescription.match(regex) || []).length;

        if (count === 0) {
          this.fundoscopy.description += ` ${title} `;
        }
      }

      if (this.attendanceEsigned) return;

      if (e) {
        if (this.verifyDescription()) {
          this.fundoscopy.description = `${e.text}${textAfter}`;
        } else if (this.fundoscopy.description.slice(-1) === ":") {
          this.fundoscopy.description += ` ${textBefore}${e.text}${textAfter}`;

        } else if (this.fundoscopy.description.slice(-1) === "," && removeLastChar === true) {
          let newDescription = this.fundoscopy.description.slice(0, -1);
          newDescription += ` ${textBefore}${e.text}${textAfter}`;
          this.fundoscopy.description = newDescription;
        } else if (this.fundoscopy.description.slice(-1) === " ") {
          this.fundoscopy.description += `${e.text}${textAfter}`;
        } else if (this.fundoscopy.description.slice(-1) === "\n") {
          this.fundoscopy.description += `${e.text}${textAfter}`;
        } else {
          this.fundoscopy.description += ` ${e.text}${textAfter}`;
        }
      }

      this.facilitator = [];
      this.saveManager.dispatchAutoSave();
    },

    verifyDescription() {
      return (this.fundoscopy.description === null || this.fundoscopy.description.trim() === "");
    },

    handleDescriptionChange() {
      this.saveManager.dispatchAutoSave();
    },

    handleNormal() {
      if (this.attendanceEsigned) return;

      let text = `VITREO: SILENCIOSO, PAPILA: PAPILA CORADA COM BORDOS NÍTIDOS, VASOS: VASOS COM CALIBRE E TRAJETOS NORMAIS, RETINA APLICADA, MACULA: MÁCULA COM BRILHO E ASPECTO NORMAL\n`;

      if (this.fundoscopy) {
        if (this.fundoscopy.description !== null) {
          this.fundoscopy.description += ` ${text}\n`;
          //this.fundoscopy.description = this.fundoscopy.description.trim();
        } else {
          this.fundoscopy.description = `${text}\n`;
        }
      }

      this.facilitator = [];
    },
    validateFundoscopy() {
      this.errors = {};

      if (!this.fundoscopy.description?.trim()) {
        this.errors.description = "A Fundoscopia não pode estar vazia.";
      }
    },
    beforeSave() {
      this.validateFundoscopy();
      if (this.attendanceEsigned) return false;
      if (this.hasErrors) return false;
      return true;
    },
    async onSave() {
      const { data } = await this.apolloMutate({
        mutation: SAVE_FUNDOSCOPY,
        variables: {
          attendanceId: this.attendance.id,
          description: this.fundoscopy.description,
        },
      });
      this.$set(this.fundoscopy, "updatedAt", data.saveFundoscopy.updatedAt);
    },
  },
};
</script>

<style lang="scss" scoped></style>
